import { useState } from 'react'
import { Link } from 'react-router'
import { partners } from '../data/partners'
import { useT } from '../i18n/useT'

export default function ProPartners() {
  const t = useT()
  const [prov, setProv] = useState<string>('ALL')

  const provs = ['ALL', 'AB', 'BC', 'ON', 'QC'] as const
  const count = (p: string) => (p === 'ALL' ? partners.length : partners.filter((x) => x.prov === p).length)
  const list = prov === 'ALL' ? partners : partners.filter((p) => p.prov === prov)
  const provLabel = (p: string) => (p === 'ALL' ? t.pro.filterAll : p)

  return (
    <>
      {/* hero */}
      <section className="bg-gradient-to-b from-brand-50 via-white to-white">
        <div className="mx-auto max-w-7xl px-8 pt-20 pb-14 text-center">
          <h1 className="text-5xl font-extrabold mb-5">{t.pro.h}</h1>
          <p className="text-lg text-ink-mute max-w-3xl mx-auto">{t.pro.sub}</p>
        </div>
      </section>

      {/* filter + directory */}
      <section className="bg-white">
        <div className="mx-auto max-w-7xl px-8 pb-24">
          <div className="flex flex-wrap gap-2.5 mb-10">
            {provs.map((p) => (
              <button
                key={p}
                onClick={() => setProv(p)}
                aria-pressed={prov === p}
                className={`rounded-lg border px-5 py-2 text-sm font-semibold whitespace-nowrap transition-colors ${
                  prov === p
                    ? 'border-brand-600 bg-brand-600 text-white'
                    : 'border-slate-200 text-ink-soft hover:border-slate-300'
                }`}
              >
                {provLabel(p)} · {count(p)}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-2 gap-6">
            {list.map((p) => (
              <div
                key={p.name}
                className="rounded-2xl border border-slate-100 p-8 flex flex-col hover:border-brand-300 hover:shadow-[0_16px_40px_-16px_rgb(22_163_74/0.2)] transition-all"
              >
                <div className="flex items-start justify-between gap-4 mb-5">
                  <img
                    src={p.logo}
                    alt={p.name}
                    className="h-11 w-auto max-w-[190px] object-contain object-left"
                  />
                  <span className="shrink-0 rounded-full bg-brand-100 text-brand-800 text-xs font-semibold px-3 py-1">
                    {p.prov}
                  </span>
                </div>
                <h2 className="text-lg font-bold mb-1">{p.name}</h2>
                <p className="text-sm text-ink-mute mb-4">{p.city}, {p.prov}</p>
                <p className="text-[15px] leading-relaxed text-ink-mute mb-6 flex-1 line-clamp-4">
                  {p.blurb}
                </p>
                <a
                  href={p.url}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 font-semibold text-brand-700 self-start"
                >
                  {t.pro.visit}
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.2} className="w-4 h-4">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14M13 6l6 6-6 6" />
                  </svg>
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* become a partner CTA */}
      <section className="bg-mist">
        <div className="mx-auto max-w-7xl px-8 py-16 text-center">
          <h2 className="text-3xl font-extrabold mb-4">{t.pro.become.h}</h2>
          <p className="text-lg text-ink-mute max-w-xl mx-auto mb-8">{t.pro.become.sub}</p>
          <Link
            to="#"
            className="inline-block rounded-md bg-brand-600 hover:bg-brand-700 transition-colors text-white font-semibold px-7 py-3.5"
          >
            {t.pro.become.button}
          </Link>
        </div>
      </section>
    </>
  )
}
